import React from "react";
import LooksGalleryButton from "./LooksGalleryButton";
import WaysToStyleGalleryButton from "./WaysToStyleGalleryButton";
import { useWaysToStyle } from "../../context/waysToStyle/WaysToStyleContext";

const HeroGalleryBuyTheLook: React.FC = () => {
  const { shouldShowWaysToStyle, isWaysToStyleFeatureDecided } =
    useWaysToStyle();

  if (!isWaysToStyleFeatureDecided) {
    return null;
  }

  return shouldShowWaysToStyle ? (
    <WaysToStyleGalleryButton />
  ) : (
    <LooksGalleryButton />
  );
};

export default HeroGalleryBuyTheLook;
